import { differenceInDays } from 'date-fns';
import { CompactUser, useUserContext } from 'src/context/user';
import { getCurrentDate } from 'src/utils/dateTime';

type CohortDefinition = {
  key: string;
  condition: (user: CompactUser) => boolean;
};

const ALL_USERS_COHORT = 'all-users';

const createDaysIntervalCondition = (startDay: number, endDay: number | null) => {
  return (user: CompactUser) => {
    if (!user.dateJoined) return false;

    const diff = differenceInDays(getCurrentDate(), user.dateJoined);

    return diff >= startDay && (endDay === null || diff <= endDay);
  };
};

const COHORTS: CohortDefinition[] = [
  {
    key: ALL_USERS_COHORT,
    condition: () => true,
  },
  {
    key: 'pro-users',
    condition: user => user.isPro,
  },
  {
    key: 'd0-d1-users',
    condition: createDaysIntervalCondition(0, 1),
  },
  {
    key: 'd2-d13-users',
    condition: createDaysIntervalCondition(2, 13),
  },
  {
    key: 'd0-d13-users',
    condition: createDaysIntervalCondition(0, 13),
  },
  {
    key: 'd14-d60-users',
    condition: createDaysIntervalCondition(14, 60),
  },
  {
    key: 'long-term-users',
    condition: createDaysIntervalCondition(61, null),
  },
];

export function useUserCohorts() {
  const { user } = useUserContext();

  if (!user) return [ALL_USERS_COHORT];

  return COHORTS.filter(c => c.condition(user))
    .map(c => c.key)
    .sort();
}
